<div class="alert" style="margin-bottom: 0px;">
  <div class="modal-header ">
    <h4 class="modal-title pull-left">{{ dialogHeaderText }}</h4>
  </div>
  <div class="modal-body"  >
    <sl-lpms-update-subfolder-dialog-form [shouldShowAddSubfolderNameButton]="shouldShowAddSubfolderNameButton" [invalidNames]="data.invalidNames" [bindTo]="folder"></sl-lpms-update-subfolder-dialog-form>
  </div>
  <div class="modal-footer justify-content-center">
    <button id="confirmation-dialog-ok-button" [disabled]="isOkDisabled"   type="button" class="btn s_btn-confirmation-ok mr-2"   [ngClass]="getOkButtonClass()"  (click)="closeModal(ConfirmationDialogButton.Ok)">
      <div [attr.data-test-id]="'subfolder-dialog-ok-button'"  [innerHTML]="okBtnName ? okBtnName : 'OK'"></div>
      @if (hasOkSubtext()) {
        <div class="s_subtext">{{okBtnSubtext}}</div>
      }
    </button>
    <button [attr.data-test-id]="'subfolder-dialog-cancel-button'" id="confirmation-dialog-cancel-button"  [disabled]="closeDialogRequestedBy != null"   type="button" class="btn s_btn-confirmation-cancel mr-2" [ngClass]="getCancelButtonClass()" (click)="closeModal(ConfirmationDialogButton.Cancel)">
      <div [innerHTML]="cancelBtnName ? cancelBtnName : 'CANCEL'"></div>
      @if (hasCancelSubtext()) {
        <div class="s_subtext">{{cancelBtnSubtext}}</div>
      }
    </button>
  </div>
</div>
<ng-template #matterSubtypeTemplate let-model="item">
  <span class="subtypePicklist">{{model.name}}</span>

</ng-template>